"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deterministicSelection = void 0;
// Code inspired by https://codereview.stackexchange.com/questions/149894/making-a-semi-random-order-of-an-array-based-on-a-string
// And https://github.com/garycourt/murmurhash-js/
const murmurhash_js_1 = require("murmurhash-js");
// Creates a random number generator function
function createRandomGenerator(seed) {
    // some big numbers
    const a = 5486230734;
    const b = 6908969830;
    const m = 9853205067;
    let x = seed;
    // returns a random value 0 <= num < 1
    return function generate() {
        // seed is optional. If supplied sets a new seed
        x = (seed * a + b) % m;
        return x / m;
    };
}
/**
 * This function will pseudorandomly select a value from the array
 * of values given a string `s`.
 *
 * @example
 * ```
 * const result = deterministicSelection("abc", [1, 2, 3])
 * // result is always 2
 * ```
 */
function deterministicSelection(s, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
values) {
    const hashedString = (0, murmurhash_js_1.murmur3)(s);
    const random = createRandomGenerator(hashedString)();
    return values[Math.floor(random * values.length)];
}
exports.deterministicSelection = deterministicSelection;
